export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q05_b.94332690.png";